import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ImagePlus, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const LogoUpload = ({ kind = "empresa" }) => {
  const { user, refresh } = useAuth();
  const ep = kind === "contrato" ? "/settings/company/logo-contrato" : "/settings/company/logo";
  const [has, setHas] = useState(kind === "contrato" ? null : !!user?.empresa?.logo);
  useEffect(() => { if (kind === "contrato") api.get(ep, { responseType: "blob" }).then(() => setHas(true)).catch(() => setHas(false)); }, [kind, ep]);
  const [v, setV] = useState(Date.now());
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  useEffect(() => setHas(!!user?.empresa?.logo), [user]);
  const src = `${process.env.REACT_APP_BACKEND_URL}/api${ep}?v=${v}`;

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setLoading(true);
    try { await api.post(ep, fd); toast.success(kind === "contrato" ? "Logo dos documentos atualizada!" : "Logo do sistema atualizada!"); setHas(true); setV(Date.now()); refresh?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao enviar logo"); }
    finally { setLoading(false); }
  };
  const remove = async () => { await api.delete(ep); setHas(false); refresh?.(); toast.success(kind === "contrato" ? "Logo dos documentos removida — PDFs usarão a logo do sistema" : "Logo do sistema removida"); };

  return (
    <div className="mt-6 border-t pt-5" data-testid={kind === "contrato" ? "logo-contrato-upload" : "logo-upload"}>
      <Label className="text-xs">{kind === "contrato" ? "Logo dos documentos — contratos, recibos e demais PDFs (se vazio, usa a logo do sistema da sua empresa)" : "Logo do sistema — Dashboard, painel, portal e link público"}</Label>
      <div className="mt-2 flex items-center gap-4 flex-wrap">
        <div className="w-40 h-20 rounded-lg bg-onyx flex items-center justify-center overflow-hidden border">
          {has ? <img src={src} alt="logo" className="max-h-16 max-w-[150px] object-contain" data-testid={kind === "contrato" ? "logo-contrato-preview" : "logo-preview"} /> : <span className="text-slate-400 text-xs">{kind === "contrato" ? "Sem logo própria (usa a do sistema)" : "Sem logo (padrão)"}</span>}
        </div>
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={kind === "contrato" ? "logo-contrato-file-input" : "logo-file-input"} />
        <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={loading} className="gap-2" data-testid={kind === "contrato" ? "logo-contrato-upload-btn" : "logo-upload-btn"}>{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />} {has ? "Trocar logo" : "Enviar logo"}</Button>
        {has && <Button type="button" variant="ghost" onClick={remove} className="text-red-600 gap-1" data-testid={kind === "contrato" ? "logo-contrato-remove-btn" : "logo-remove-btn"}><Trash2 className="w-4 h-4" /> Remover</Button>}
      </div>
      <p className="text-xs text-slate-400 mt-2">PNG com fundo transparente, JPG ou WEBP, até 3MB. A imagem é usada como enviada (sem recorte, sem remoção de fundo, proporção preservada).</p>
    </div>
  );
};
